import React from 'react';
import {
  Container,
  Typography,
  Box,
  Paper,
} from '@mui/material';

const EditorialPolicy = () => {
  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Paper elevation={1} sx={{ p: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom color="primary">
          Editorial Policy
        </Typography>
        
        <Typography variant="body1" paragraph>
          PharmaMan is committed to providing accurate, reliable, and up-to-date health information to our users. This Editorial Policy outlines our standards for content creation, review, and maintenance.
        </Typography>

        <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 3 }}>
          Content Standards
        </Typography>
        
        <Typography variant="body1" paragraph>
          All content published on PharmaMan undergoes rigorous review to ensure:
        </Typography>
        
        <Box component="ul" sx={{ pl: 2 }}>
          <Typography component="li" variant="body1">Accuracy and factual correctness</Typography>
          <Typography component="li" variant="body1">Relevance to our users' health needs</Typography>
          <Typography component="li" variant="body1">Compliance with medical and pharmaceutical regulations</Typography>
          <Typography component="li" variant="body1">Clear, understandable language</Typography>
          <Typography component="li" variant="body1">Regular updates to reflect current medical knowledge</Typography>
        </Box>

        <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 3 }}>
          Medical Disclaimer
        </Typography>
        
        <Typography variant="body1" paragraph>
          The information provided on PharmaMan is for educational purposes only and should not be considered as medical advice. Users should always consult with qualified healthcare professionals before making any health-related decisions.
        </Typography>

        <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 3 }}>
          Content Sources
        </Typography>
        
        <Typography variant="body1" paragraph>
          Our content is sourced from:
        </Typography>
        
        <Box component="ul" sx={{ pl: 2 }}>
          <Typography component="li" variant="body1">Licensed healthcare professionals</Typography>
          <Typography component="li" variant="body1">Peer-reviewed medical journals</Typography>
          <Typography component="li" variant="body1">Government health agencies</Typography>
          <Typography component="li" variant="body1">Reputable medical institutions</Typography>
        </Box>

        <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 3 }}>
          Review Process
        </Typography>
        
        <Typography variant="body1" paragraph>
          All content undergoes a multi-step review process including medical review, editorial review, and fact-checking before publication. Content is regularly updated to ensure accuracy and relevance.
        </Typography>

        <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 3 }}>
          Contact Us
        </Typography>
        
        <Typography variant="body1" paragraph>
          If you have questions about our editorial policy or would like to report any concerns about our content, please contact us at editorial@pharmaman.com
        </Typography>
      </Paper>
    </Container>
  );
};

export default EditorialPolicy;